(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ares-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const groups = () => document.querySelectorAll('.ah details[open]');
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    groups().forEach((el) => {
      el.open = false;
      el.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    groups().forEach((el) => {
      if (!el.contains(event.target)) el.open = false;
    });
  });
  document.addEventListener('toggle', (event) => {
    const el = event.target;
    if (!(el instanceof HTMLDetailsElement) || !el.closest('.ah') || !el.open) return;
    groups().forEach((other) => { if (other !== el && !other.contains(el)) other.open = false; });
    if (el.matches('[data-ah-search]')) el.querySelector('input[type="search"]')?.focus();
  }, true);
  const counts = () => document.querySelectorAll('[data-af-cart-count]');
  const sync = (el) => { el.hidden = !(Number(el.textContent) > 0); };
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      window.fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
        .then((r) => r.json())
        .then((cart) => counts().forEach((el) => { el.textContent = cart.item_count; sync(el); }))
        .catch(() => {});
    }, 300);
  };
  counts().forEach((el) => new MutationObserver(() => sync(el)).observe(el, { childList: true, characterData: true, subtree: true }));
  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, options) {
    const promise = nativeFetch(input, options);
    try {
      const url = new URL(input instanceof Request ? input.url : input, location.href);
      if (url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) promise.then(refresh, refresh);
    } catch (e) {}
    return promise;
  };
  ['cart:update', 'cart-section:restored'].forEach((name) => document.addEventListener(name, refresh));
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ares-order-builder"] && !Shopify.designMode) return;
  try {
    
function setupAresOrders(scope=document){scope.querySelectorAll('.af-order:not([data-ready])').forEach(form=>{form.dataset.ready='true';const inputs=[...form.querySelectorAll('[data-variant]')];const status=form.querySelector('[role="status"]');const button=form.querySelector('button[type="submit"]');const label=button.textContent;const total=form.querySelector('[data-total]');const format=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:form.dataset.currency||'AUD'});function refresh(){const quantity=inputs.filter(input=>!input.disabled&&input.dataset.quickchem==='true').reduce((sum,input)=>sum+Math.max(0,Number(input.value)||0),0);const eligible=form.dataset.quickchemOffer==='true'&&quantity>=3;let saving=0;const subtotal=inputs.filter(input=>!input.disabled).reduce((sum,input)=>{const count=Math.max(0,Number(input.value)||0);const price=Number(input.dataset.price);const reduction=eligible&&input.dataset.quickchem==='true'?Math.min(1000,price):0;saving+=count*reduction;return sum+count*(price-reduction)},0);total.textContent=format.format(subtotal/100);const offer=form.querySelector('[data-offer-status]');if(offer){offer.textContent=eligible?form.dataset.qualified:form.dataset.unqualified;form.querySelector('[data-offer-saving]').hidden=!eligible;form.querySelector('[data-saving]').textContent=format.format(saving/100)}}form.addEventListener('input',refresh);refresh();form.addEventListener('submit',async event=>{event.preventDefault();if(!form.reportValidity())return;const items=inputs.filter(input=>!input.disabled&&Number(input.value)>0).map(input=>({id:input.dataset.variant,quantity:Number(input.value)}));if(!items.length){status.textContent=form.dataset.empty;return}button.disabled=true;button.textContent=form.dataset.adding;status.textContent='';try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||form.dataset.error);window.location.assign(window.Shopify.routes.root+'cart')}catch(error){status.textContent=error.message||form.dataset.error;button.disabled=false;button.textContent=label}})})}
setupAresOrders();document.addEventListener('shopify:section:load',event=>setupAresOrders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ares-seed-calculator"] && !Shopify.designMode) return;
  try {
    
function setupSeedCalculators(scope=document){scope.querySelectorAll('.sc-form:not([data-ready])').forEach(form=>{form.dataset.ready='true';const output=form.querySelector('output');form.addEventListener('input',()=>{output.textContent=''});form.addEventListener('submit',e=>{e.preventDefault();const values=['target','tgw','germ','est'].map(k=>Number(form.elements[k].value));if(!form.reportValidity()||values.some(v=>!Number.isFinite(v)||v<=0)||values[2]>100||values[3]>100){output.textContent=form.dataset.invalid;return}const rate=values[0]*values[1]*100/(values[2]*values[3]);output.textContent=form.dataset.result+': '+rate.toFixed(1)+' '+form.dataset.unit})})}setupSeedCalculators();document.addEventListener('shopify:section:load',e=>setupSeedCalculators(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ares-seed-chooser"] && !Shopify.designMode) return;
  try {
    
function setupSeedSizes(){const chooser=document.querySelector('.ss-chooser');if(!chooser||chooser.dataset.ready)return;chooser.dataset.ready='true';const ranges=[...document.querySelectorAll('[data-seed-range]')];function select(size){ranges.forEach(range=>range.hidden=range.dataset.seedRange!==size);chooser.querySelectorAll('[data-seed-size]').forEach(link=>{if(link.dataset.seedSize===size)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current')})}function fromHash(){const size=location.hash.includes('large-inserts')?'large':'medium';select(size)}chooser.addEventListener('click',event=>{const link=event.target.closest('[data-seed-size]');if(link)select(link.dataset.seedSize)});window.addEventListener('hashchange',fromHash);fromHash()}
setupSeedSizes();document.addEventListener('shopify:section:load',setupSeedSizes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ares-seed-offer"]) return;
  try {
    
(() => {
  const panel = document.querySelector('[data-seed-offer]');
  if (!panel || window.AresSeedSmart) return;
  const eligible = new Set([15808997589065,15808999522377,15809001586761,15809004798025,15809006305353,15809007353929,15809011875913,15809013612617,15809031602249,15809033306185]);
  const groups = [{eligible, gift:Number(panel.dataset.gift), available:panel.dataset.available==='true'}, {eligible:new Set([15817672556617, 15817996959817, 15818000695369, 15818004267081, 15818013474889, 15818014949449, 15818018947145, 15818022518857, 15818028482633, 15818031169609]), gift:Number(panel.dataset.mediumGift), available:panel.dataset.mediumAvailable==='true'}];
  const root = window.Shopify.routes.root;
  const originalFetch = window.fetch.bind(window);
  let running = Promise.resolve(), timer, navigating = false;
  const pending = new Set();
  function notice(message) { panel.hidden = !message; panel.querySelector('p').textContent = message || ''; }
  async function request(path, body) {
    const response = await originalFetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || panel.dataset.error);
    return data;
  }
  async function sync() {
    await Promise.allSettled([...pending]);
    let cart = await request('cart.js');
    let changed = false, unavailable = false;
    for (const group of groups) {
      const count = cart.items.reduce((n,item)=>n+(group.eligible.has(item.product_id)?item.quantity:0),0);
      const gifts = cart.items.filter(item=>item.variant_id===group.gift);
      const automatic = gifts.filter(item=>item.properties?._ares_seedsmart_gift==='yes');
      const manual = gifts.filter(item=>item.properties?._ares_seedsmart_gift!=='yes');
      const updates = {};
      automatic.forEach((item,index)=>{const wanted=count>=3&&!manual.length&&index===0?1:0;if(item.quantity!==wanted)updates[item.key]=wanted});
      if(Object.keys(updates).length){cart=await request('cart/update.js',{updates});changed=true}
      if(count>=3&&!cart.items.some(item=>item.variant_id===group.gift)){
        if(!group.gift||!group.available){unavailable=true;continue}
        try {await request('cart/add.js',{items:[{id:group.gift,quantity:1,properties:{_ares_seedsmart_gift:'yes'}}]});cart=await request('cart.js');changed=true}
        catch(error){unavailable=true}
      }
    }
    const paidGifts=cart.items.filter(item=>groups.some(group=>group.gift===item.variant_id)&&item.properties?._ares_seedsmart_gift==='yes'&&item.final_line_price>0);
    if(paidGifts.length){const updates={};paidGifts.forEach(item=>updates[item.key]=0);cart=await request('cart/update.js',{updates});unavailable=true;changed=true}
    notice(unavailable?panel.dataset.unavailable:'');
    document.querySelectorAll('[data-af-cart-count]').forEach(el=>el.textContent=cart.item_count);
    return {cart,changed};
  }
  function reconcile(){running=running.catch(()=>{}).then(sync);return running}
  function refreshSoon(){clearTimeout(timer);timer=setTimeout(()=>reconcile().then(({changed})=>{if(changed&&location.pathname.replace(/\/$/,'')===root+'cart'&&!navigating)location.reload()}).catch(()=>notice(panel.dataset.error)),250)}
  window.AresSeedSmart={reconcile};

  window.fetch=function(input,options){
    const url=new URL(input instanceof Request?input.url:input,location.href);
    const isCart=url.origin===location.origin&&/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    const promise=originalFetch(input,options);
    if(isCart){pending.add(promise);promise.finally(()=>{pending.delete(promise);refreshSoon()}).catch(()=>{})}
    return promise;
  };
  document.addEventListener('cart:update',refreshSoon);
  document.addEventListener('cart-section:restored',refreshSoon);
  window.addEventListener('pageshow',refreshSoon);

  document.addEventListener('click',event=>{
    const control=event.target.closest('[name="checkout"],a[href="/checkout"]');
    if(!control)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(navigating)return;navigating=true;notice(panel.dataset.checking);
    clearTimeout(timer);
    reconcile().then(()=>{window.location.assign(root+'checkout')}).catch(()=>{navigating=false;notice(panel.dataset.error)});
  },true);
  refreshSoon();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ares-seed-range"] && !Shopify.designMode) return;
  try {
    
function setupSeedBuilders(scope=document){scope.querySelectorAll('.ss-builder:not([data-ready])').forEach(form=>{form.dataset.ready='true';if(form.hasAttribute('data-enquiry')){form.addEventListener('submit',e=>e.preventDefault());form.querySelector('.ss-filter').hidden=false;form.querySelector('[data-crop-filter]').addEventListener('change',event=>{form.querySelectorAll('[data-crop]').forEach(card=>card.hidden=event.target.value!=='all'&&card.dataset.crop!==event.target.value)});return}const inputs=[...form.querySelectorAll('[data-variant]')],button=form.querySelector('button[type="submit"]'),label=button.textContent,status=form.querySelector('[role="status"]'),formatter=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:form.dataset.currency||'AUD'});function refresh(){const count=inputs.filter(i=>!i.disabled).reduce((sum,i)=>sum+Math.max(0,Number(i.value)||0),0);form.querySelector('[data-selected]').textContent=count;form.querySelector('[data-progress]').textContent=count>=3?form.dataset.qualified:count?form.dataset.more.replace('{count}',3-count):form.dataset.none;form.querySelector('[data-total]').textContent=formatter.format(inputs.filter(i=>!i.disabled).reduce((sum,i)=>sum+Math.max(0,Number(i.value)||0)*Number(i.dataset.price),0)/100)}form.addEventListener('input',refresh);refresh();form.querySelector('.ss-filter').hidden=false;form.querySelector('[data-crop-filter]').addEventListener('change',event=>{form.querySelectorAll('[data-crop]').forEach(card=>card.hidden=event.target.value!=='all'&&card.dataset.crop!==event.target.value)});form.addEventListener('submit',async e=>{e.preventDefault();if(!form.reportValidity())return;const items=inputs.filter(i=>!i.disabled&&Number(i.value)>0).map(i=>({id:i.dataset.variant,quantity:Number(i.value)}));if(!items.length){status.textContent=form.dataset.empty;return}button.disabled=true;button.textContent=form.dataset.adding;status.textContent='';try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||form.dataset.error);if(window.AresSeedSmart)await window.AresSeedSmart.reconcile();window.location.assign(window.Shopify.routes.root+'cart')}catch(error){status.textContent=error.message||form.dataset.error;button.disabled=false;button.textContent=label}})})}
setupSeedBuilders();document.addEventListener('shopify:section:load',e=>setupSeedBuilders(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
